import React from 'react';
import { useFormContext } from 'react-hook-form';
import { Checkbox } from '@morressier/alembic';
import { FormFieldCheckbox as IFormFieldCheckbox } from '@publishing-engine/domain/types/article';
import { Flex } from '@chakra-ui/react';
import { parseStringWithLinks } from 'src/utils/parseStringWithLinks';
import { FieldLabel } from 'src/components/Field';
import FormFieldErrorMessage from 'src/components/FormField/common/FormFieldErrorMessage';

interface OpenAccessOnlyProps {
  config: IFormFieldCheckbox;
}

const OpenAccessOnly: React.FC<OpenAccessOnlyProps> = ({ config }) => {
  const { register, setValue, watch, clearErrors } = useFormContext();

  const {
    name,
    params: { validations, labels },
    caseDataFields: { main: field }
  } = config;

  const registeredField = register(field, { required: validations.required });

  const model = watch('preference.publishingModel.model');
  const acknowledgeCharge = watch(
    'preference.publishingModel.acknowledgeCharge'
  );

  const checked = model === 'openAccess' && acknowledgeCharge === true;

  return (
    <Flex flexDirection="column" alignItems="flex-start" gap={2} width="100%">
      <FieldLabel
        isRequired={validations.required}
        label={labels.main}
        subText={labels.subtitle}
      />

      <Checkbox
        ariaLabel={labels.main}
        id={name}
        {...registeredField}
        checked={checked}
        onChange={e => {
          const checked = e.target.checked;

          if (checked) {
            setValue('preference.publishingModel.model', 'openAccess');
            setValue('preference.publishingModel.acknowledgeCharge', true);
            clearErrors(field);
          } else {
            setValue('preference.publishingModel', null);
          }
        }}
      >
        {parseStringWithLinks(labels.content || labels.subtitle)}
      </Checkbox>

      <FormFieldErrorMessage config={config} />
    </Flex>
  );
};

export default OpenAccessOnly;
